import { ANNUALLY, BillingPeriodType, MONTHLY } from '@constants/billingPeriods'
import { CurrencyType } from '@constants/currencies'
import { Icon, Paragraph, Spreader } from '@landingi/landingi-ui-kit'
import styles from '@pages/Pricing/routes/AccountPackage/components/PlanPanels/components/SummarySubscriptionModal/SummarySubscriptionModal.module.scss'
import { Badge } from '@ui-kit'
import { Fragment } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Row } from 'simple-flexbox'

export const BillingCycle = ({
  billingPeriod,
  currency,
  annualSaving,
  shouldDisplayPromotion3MBadge,
  shouldDisplayPromotion1MBadge
}: {
  billingPeriod: BillingPeriodType
  currency: CurrencyType
  annualSaving: number | string
  shouldDisplayPromotion3MBadge?: boolean
  shouldDisplayPromotion1MBadge?: boolean
}) => {
  const { t } = useTranslation()

  const billingCycleText =
    billingPeriod === MONTHLY
      ? t('change.plan.page.billed.monthly')
      : t('change.plan.page.billed.annually')

  return (
    <div className={styles['summary-subscription-modal__row']}>
      <div className={styles['summary-subscription-modal__icon']}>
        <Icon icon='icon-calendar-check-outline' size={14} />
      </div>

      <div>
        <Paragraph weight={400} line={20} size={16} padding='none'>
          <Trans i18nKey='change.plan.page.billing.cycle' />
        </Paragraph>
      </div>

      <Row vertical='center'>
        <Paragraph weight={400} line={20} size={16} padding='none'>
          {billingCycleText}
          {shouldDisplayPromotion3MBadge && (
            <Fragment>
              <Spreader spread='mini' />

              <Badge variant='warning-border' weight={600}>
                {t('promotion3M.50percent.x.3months')}
              </Badge>
            </Fragment>
          )}

          {shouldDisplayPromotion1MBadge && (
            <Fragment>
              <Spreader spread='mini' />

              <Badge variant='warning-border' weight={600}>
                {t('promotion.for.free.plan.50percent.x.1month')}
              </Badge>
            </Fragment>
          )}
        </Paragraph>

        <Spreader spread='tiny' />

        {billingPeriod === ANNUALLY && (
          <Badge variant='warning-filled' weight={600}>
            {t('change.plan.page.save')} {annualSaving} {currency}
          </Badge>
        )}
      </Row>
    </div>
  )
}
